import { render, staticRenderFns } from "./ListWineries.vue?vue&type=template&id=c260ec10&"
import script from "./ListWineries.vue?vue&type=script&lang=js&"
export * from "./ListWineries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports